import React, { useEffect } from 'react';

// Wraps the 3 TV dashboards (Supervisor, Plant Head, Downtime) with zero admin
// chrome — no sidebar, no topbar, no logout button. These screens run
// unattended on a wall-mounted smart TV pointed permanently at one URL, so
// there is nothing here for anyone to click or navigate away from.
export default function TvShell({ children }) {
  useEffect(() => {
    // Full-bleed: remove any inherited body margin/scroll quirks so the
    // dashboard's own background fills the entire TV screen edge-to-edge.
    document.body.style.margin = '0';
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.margin = '';
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div style={{ width: '100vw', minHeight: '100vh', margin: 0, padding: 0 }}>
      {children}
    </div>
  );
}